/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/room/ground.ts
 * @Author: Yongchao Wang
 * @Date: 2021-12-14 17:09:47
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-11 10:35:02
 * @Description: 地面
 */
import { Constants, PBRMetallicRoughnessMaterial, PolygonMeshBuilder, Texture, } from '@babylonjs/core';
import * as earCut from 'earcut';
export default class Ground {
    constructor(scene, engine, size) {
        this.scene = scene;
        this.engine = engine;
        this.size = size;
    }
    /**
     * @description: 创建地面
     * @param {Array} points 点集合
     * @param {Vector3} position 位置
     * @return {*}
     * @author: Yongchao Wang
     */
    createGround(points, position) {
        const builder = new PolygonMeshBuilder('ground', points, this.scene, earCut.default);
        this.groundMesh = builder.build();
        this.groundMesh.position = position;
        this.groundMesh.name = 'ground';
        this.groundMesh.id = 'ground';
        this.groundMesh.receiveShadows = true;
        this.groundMaterial = new PBRMetallicRoughnessMaterial('groundMtl', this.scene);
        this.groundMaterial.metallic = 0;
        this.groundMaterial.roughness = 0.3;
        this.groundMesh.material = this.groundMaterial;
    }
    changeMaterial(groundTextureUrl, groundNormalTextureUrl, size = { width: 0.08, height: 0.08 }) {
        if (!this.groundMesh || !this.groundMesh.material) {
            return;
        }
        console.log(this.groundMesh.getBoundingInfo());
        let uscale = 1;
        let vscale = 1;
        if (size === null || size === void 0 ? void 0 : size.width) {
            uscale = this.size.width / size.width;
            vscale = this.size.height / size.height;
        }
        const floorMtl = this.groundMesh.material;
        const floorTexture = new Texture(groundTextureUrl, this.scene, false, false, Constants.TEXTURE_TRILINEAR_SAMPLINGMODE, () => {
            if (size === null || size === void 0 ? void 0 : size.width) {
                floorTexture.uScale = uscale;
                floorTexture.vScale = vscale;
            }
            floorMtl.baseTexture = floorTexture;
        });
        const floorNormalTexture = new Texture(groundNormalTextureUrl, this.scene, false, false, Constants.TEXTURE_TRILINEAR_SAMPLINGMODE, () => {
            if (size === null || size === void 0 ? void 0 : size.width) {
                floorTexture.uScale = uscale;
                floorTexture.vScale = vscale;
            }
            floorMtl.normalTexture = floorNormalTexture;
        });
    }
}
